import {
  carrierDispatchPageConfig,
  getCarrierDispatchExportConfig,
} from '@components/OrderMovements/OrderMovements/MovementDetail/BOL/Detail/constants'
import { UploadDownloadButtons } from '@components/_SiteWide/UploadStatus/UploadDownloadButtons'
import { Horizontal, onExport } from '@gravitate-js/excalibrr'
import api from '@utils/api'
import { Divider, Select } from 'antd'

import { DateRangeFilter } from '../../../../../components/_SiteWide/DateRangeFilter'
import { OrderTankToggle } from './OrderTankToggle'

import type { Filter } from '@gravitate-js/excalibrr/dist/components/Grid/SearchGridHeader/DynamicFilterForm/types'
import type { GridApi } from 'ag-grid-community'
import type { OrderManagementGridView } from '@/pages/OrderManagement/All/types'
import type { UserSettingsHook } from '@/hooks/settings'
import type { DayRange } from '@/hooks/useDateRangeFilter'

type CarrierDispatchActionBtnsProps = {
  gridAPIRef: React.MutableRefObject<GridApi>
  orderStatus: string
  setOrderStatus: (status: string) => void
  filters: Filter
  setFilters: (filters: Filter) => void
  getDatesFromStorage: boolean
  orderManagementDayRange: DayRange
  setOrderManagementDayRange: (value: DayRange) => void
  updateSetting: UserSettingsHook['updateSetting']
  selectedView: OrderManagementGridView
  setSelectedView: (view: OrderManagementGridView) => void
}

export function CarrierDispatchActionBtns({
  gridAPIRef,
  orderStatus,
  setOrderStatus,
  filters,
  setFilters,
  getDatesFromStorage,
  orderManagementDayRange,
  setOrderManagementDayRange,
  updateSetting,
  selectedView,
  setSelectedView,
}: CarrierDispatchActionBtnsProps) {
  const onStatusChange = (value) => {
    if (value === 'all_od') {
      setFilters((prevState) => {
        return {
          ...prevState,
          ...carrierDispatchPageConfig[value].filters,
          state: undefined,
          notification_state: undefined,
        }
      })
    } else {
      setFilters((prevState) => {
        return { ...prevState, ...carrierDispatchPageConfig[value].filters }
      })
    }
    updateSetting('order-management-od-status', value)
    setOrderStatus(value)
    localStorage.setItem('order-management-od-status', value)
  }
  const options = [
    {
      key: 'all_od',
      value: 'all_od',
      label: (
        <>
          <Horizontal className='mt-2' gap={4} fullHeight verticalCenter>
            <span className='all dot mr-1' />
            <span>{carrierDispatchPageConfig.all_od.option}</span>
          </Horizontal>
          <Divider className='p-0 m-1' />
        </>
      ),
    },
    {
      key: 'open_od',
      value: 'open_od',
      label: (
        <>
          <Horizontal className='mt-2' gap={4} fullHeight verticalCenter>
            <span className='all_open dot mr-1' />
            <span>{carrierDispatchPageConfig.open_od.option}</span>
          </Horizontal>
          <Divider className='p-0 m-1' />
        </>
      ),
    },
    {
      key: 'assigned_od',
      value: 'assigned_od',
      label: (
        <div className='ml-4 open-option' data-cy='Assigned Filter Button'>
          {carrierDispatchPageConfig.assigned_od.option}
        </div>
      ),
    },
    {
      key: 'staged',
      value: 'staged',
      label: (
        <div className='ml-4 open-option' data-cy='Staged Filter Button'>
          {carrierDispatchPageConfig.staged.option}
        </div>
      ),
    },
    {
      key: 'sent',
      value: 'sent',
      label: (
        <div className='ml-4 open-option' data-cy='Sent Filter Button'>
          {carrierDispatchPageConfig.sent.option}
        </div>
      ),
    },
    {
      key: 'completed_od',
      value: 'completed_od',
      label: (
        <>
          <Horizontal className='mt-2' gap={4} fullHeight verticalCenter>
            <span className='completed dot mr-1' />
            <span>{carrierDispatchPageConfig.completed_od.option}</span>
          </Horizontal>
          <Divider className='p-0 m-1' />
        </>
      ),
    },
    {
      key: 'canceled_od',
      value: 'canceled_od',
      label: (
        <Horizontal className='mt-2' gap={4} fullHeight verticalCenter>
          <span className='invalid dot mr-1' />
          <span>{carrierDispatchPageConfig.canceled_od.option}</span>
        </Horizontal>
      ),
    },
  ]
  return (
    <Horizontal gap={16} alignItems='center'>
      <OrderTankToggle selectedView={selectedView} setSelectedView={setSelectedView} />
      <UploadDownloadButtons
        excelOptions={[
          {
            title: 'Download Results',
            onClick: () => onExport(gridAPIRef, getCarrierDispatchExportConfig(selectedView)),
          },
          {
            title: 'Orders by Site/Product',
            downloadEP: () => api.downloadOrdersByDrops({ filter: filters }),
            fileName: 'Orders by Site/Product.csv',
          },
        ]}
      />

      <Select style={{ width: 160 }} value={orderStatus} onChange={onStatusChange} options={options} />

      <DateRangeFilter
        currentFilters={filters}
        setCurrentFilters={setFilters}
        getFromStorage={getDatesFromStorage}
        dayRangeStorage={orderManagementDayRange}
        setDayRangeStorage={setOrderManagementDayRange}
      />
    </Horizontal>
  )
}
